module.exports = __webpack_public_path__ + "static/media/RI-D2-1.1-063.ff88d0c5.webp";